import { Link } from 'react-router-dom';

const navbarItems = (subscription, account, location) => ([
  {
    label: 'Overview',
    to: '/overview',
  },
  {
    label: 'Package',
    to: '/package',
  },
  {
    label: 'Orders',
    to: '/orders',
  },
  {
    label: 'Addresses',
    to: '/addresses',
    hide: (subscription && subscription.isNonLensMail) || (account && account.isMinor),
  },
  {
    label: 'Payment Method',
    to: '/payment_method',
    // hid for all because it's not fully finished and tested
    // hide: (config.countryCode === "IE"),
    hide: true,
  },
]
  .filter((item) => !item.hide)
  .map(({ label, to }) => (
    {
      label,
      linkWrapper: { elementType: Link, elementProps: { to } },
      active: location.pathname === to,
    }
  )));

export default navbarItems;
